import HomeHero from "../../../../assets/images/heros/HOME.jpg";
import React from "react";
import Tilt from "react-parallax-tilt";

const HomeTilt = () => {
  return (
    <div className="tilt-wrapper">
      <Tilt perspective={500000} transitionSpeed={9000} tiltReverse={true}>
        <img src={HomeHero} alt="new.space Hero" style={{ width: "100%" }} />
      </Tilt>
    </div>
  );
};

export default HomeTilt;
